(() => {
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const pending = new Set();
  if (motion.matches || !('IntersectionObserver' in window) || window.Shopify?.designMode) return;
  const observer = new IntersectionObserver(entries => {
    entries.forEach(({target, isIntersecting}) => {
      if (!isIntersecting) return;
      target.classList.remove('sfs-reveal-pending');
      target.classList.add('sfs-reveal-enter');
      pending.delete(target);
      observer.unobserve(target);
    });
  }, {threshold: 0.01});
  document.querySelectorAll('.sfs-row-card, .sfs-product').forEach(card => {
    if (card.getBoundingClientRect().top < innerHeight) return;
    pending.add(card); observer.observe(card); card.classList.add('sfs-reveal-pending');
    card.addEventListener('focusin', () => {card.classList.remove('sfs-reveal-pending');pending.delete(card);observer.unobserve(card);}, {once:true});
  });
  const showAll = () => {pending.forEach(card => card.classList.remove('sfs-reveal-pending'));pending.clear();observer.disconnect();};
  motion.addEventListener('change', showAll);
  // Restore content when returning through browser history.
  addEventListener('pageshow', event => {if(event.persisted) showAll();});
})();
